export default __webpack_public_path__ + "static/Charge_Battery-1e01594ff9296940b334062b6f7f09c8.png";